const Swiper = require('swiper');
const q = require('queried');
const delegate = require('emmy/delegate');
const dialog = require('dialog-component');
const css = require('mucss/css');
const scrollbarWidth = require('mucss/scrollbar');
const animateScrollTo = require('animated-scroll-to');

const setQuestSlider = (selector) => {
  const schedule = q(selector);

  const questSlider = new Swiper(schedule, {
    autoHeight: true,
    navigation: {
      nextEl: q('.questScheduleControls-next', schedule),
      prevEl: q('.questScheduleControls-prev', schedule),
      disabledClass: 'questSchedule-control--disabled',
    },
  });

  questSlider.on('slideChange', () => {
    animateScrollTo(document.getElementById('quest-schedule').getBoundingClientRect().top + window.scrollY);
  });
};

const questBooking = (selector, options) => {
  delegate(document.body, 'click', selector, (e) => {
    const iframe = document.createElement('iframe');
    iframe.src = e.delegateTarget.getAttribute('data-iframe-src');
    css(iframe, {
      width: (options && options.width) || 560,
      height: (options && options.height) || 600,
      border: 'none',
    });

    css(document.body, {
      overflow: 'hidden',
      'margin-right': scrollbarWidth,
    });

    const closeDialog = () => {
      css(document.body, {
        overflow: null,
        'margin-right': null,
      });
    };

    dialog(null, iframe)
      .addClass('topkvestov-booking')
      .overlay()
      .escapable()
      .closable()
      .on('close', closeDialog)
      .on('hide', closeDialog)
      .show();
  });
};

module.exports = { setQuestSlider, questBooking };
